import React from 'react';
import { extractRecommendedAction } from '../taskHelpers';

/**
 * RecommendedAction - Shows the recommended action for the task
 */
function RecommendedAction({ task, fileInputRef, uploading, files }) {
  const actionText = extractRecommendedAction(task.description);
  const hasFiles = files && files.length > 0;
  
  // For manual tasks without description, show simple version
  if (!actionText && !task.source?.includes('flow')) {
    return null;
  }
  
  return (
    <div className="mb-5" data-testid="recommended-action">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-2">Dette skal du gjøre</p>
      <div className="bg-cyan-500/10 border border-cyan-500/20 rounded-xl p-4">
        {actionText ? (
          <pre className="whitespace-pre-wrap font-sans text-cyan-200 text-sm leading-relaxed">
            {actionText}
          </pre>
        ) : (
          <p className="text-sm text-cyan-200">Fullfør denne oppgaven og last opp dokumentasjon.</p>
        )}
      </div>
    </div>
  );
}

export default RecommendedAction;
